import { MARKET_BUY_BUTTON_LABEL_DEFAULT, MARKET_URL_DEFAULT } from '@/config'

export default class CatalogItemBundle {
  constructor (data) {
    if (!data) throw new Error('Invalid CatalogItemBundle data.')

    this.label = data.label ?? ''

    this.purchaseLink = data.purchaseLink ?? MARKET_URL_DEFAULT

    this.purchaseText = data.purchaseText ?? MARKET_BUY_BUTTON_LABEL_DEFAULT

    this.nomenklatura = data.nomenklatura ?? null

    this.bought = data.bought ?? null

    this.expires = data.expires ?? null

    this.items = data.items ?? []

    this.price = data.price ?? 1489

    this.oldPrice = data.old_price ?? 0
  }

  goToPurchaseLink () {
    window.open(this.purchaseLink, { target: '_blank' })
  }
}
